import { css } from 'lit';

export default css`
  :host {
    --textarea-font-size: 16px;
    --textarea-focus-box-border: 1px solid var(--theme-link-color, --colours-brand-primary);
    --textarea-focus-box-shadow: 0px 0px 3px 0px var(--theme-link-color, --colours-brand-primary);
  }
  .message-instructor {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: var(--spacing-spacing-24);

    .field {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-spacing-08);
      font-weight: 600;
    }

    .lua-textarea {
      border-radius: var(--spacing-spacing-08);
      border: 1px solid var(--colours-neutrals-gray-500);
      resize: none;
      padding: var(--spacing-spacing-08);
    }

    .lua-input {
      border-radius: var(--spacing-spacing-08);
      border: 1px solid var(--colours-neutrals-gray-500);
      padding: var(--spacing-spacing-08);
    }
  }

  .footer-buttons {
    display: flex;
    justify-content: flex-end;
    gap: var(--spacing-spacing-12);
  }
`;
